__turbopack_context__.v({
  "body-l": "style-module-scss-module__ocOnxa__body-l",
  "body-m": "style-module-scss-module__ocOnxa__body-m",
  "body-s": "style-module-scss-module__ocOnxa__body-s",
  "body-xs": "style-module-scss-module__ocOnxa__body-xs",
  "button-l": "style-module-scss-module__ocOnxa__button-l",
  "button-m": "style-module-scss-module__ocOnxa__button-m",
  "button-s": "style-module-scss-module__ocOnxa__button-s",
  "h1": "style-module-scss-module__ocOnxa__h1",
  "h1-industry": "style-module-scss-module__ocOnxa__h1-industry",
  "h2": "style-module-scss-module__ocOnxa__h2",
  "h2-industry": "style-module-scss-module__ocOnxa__h2-industry",
  "h3": "style-module-scss-module__ocOnxa__h3",
  "h3-industry": "style-module-scss-module__ocOnxa__h3-industry",
  "h4": "style-module-scss-module__ocOnxa__h4",
  "h5": "style-module-scss-module__ocOnxa__h5",
  "h5-regular": "style-module-scss-module__ocOnxa__h5-regular",
  "h6": "style-module-scss-module__ocOnxa__h6",
  "h6-regular": "style-module-scss-module__ocOnxa__h6-regular",
  "numbers-l": "style-module-scss-module__ocOnxa__numbers-l",
  "numbers-m": "style-module-scss-module__ocOnxa__numbers-m",
  "numbers-s": "style-module-scss-module__ocOnxa__numbers-s",
  "responsive": "style-module-scss-module__ocOnxa__responsive",
  "root": "style-module-scss-module__ocOnxa__root",
  "uppercase": "style-module-scss-module__ocOnxa__uppercase",
});
